// 1013 → "16m 53s", 3725 → "1h 2m 5s". Chats still going on get "(live)".
const formatDuration = (seconds, status) => {
  if (seconds === null || seconds === undefined || isNaN(Number(seconds))) return "-";
  const total = Math.max(0, Math.round(Number(seconds)));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const text = h ? `${h}h ${m}m ${s}s` : m ? `${m}m ${s}s` : `${s}s`;
  const live = ["active", "transferred"].includes(String(status || "").toLowerCase());
  return live ? `${text} (live)` : text;
};

export default formatDuration;
